/**
 * Created by yoyo on 2017/8/30.
 */
import axios from 'axios';
import Qs from 'qs';
export default {
	commonAjax:function(options){
		let	that = this,
			url = '',
			method = 'POST',
			data = options.data;
		for(let Key in options){
			switch (Key){
				case 'url':
					url = options[Key];
					break;
				case 'type':
				case 'method':
					method = options[Key];
					break;
				case 'data':
					data = options[Key];
					break;
				case 'success':
					var successfn = options[Key];
					break;
				case 'error':
				case 'fail':
					var errorfn = options[Key];
					break;
			}
		}
		console.log(Qs.stringify(data));
		axios({
			url : url,
			method : method,
			data : {
				lectorId:"234567"
			},
		}).then((res) => {
			if(that.isString(res)){
				try {
					var oData = JSON.parse(res);
				}
				catch(e) {
					oData = res;
				}
			}else{
				oData = res;
			}
			that.isFunction(successfn) && successfn(oData);
		}).catch((res) =>{
			that.isFunction(errorfn) && errorfn(res);
		});
	},
	commonAjaxForJava:function(options){
		const Constant = {
			DEVICE: 'web'
		};
		let	that = this,
			url = '',
			method = 'POST',
			data = {};

		for(let Key in options){
			switch (Key){
				case 'url':
					url = options[Key];
					break;
				case 'type':
				case 'method':
					method = options[Key];
					break;
				case 'data':
					data = options[Key];
					let loginData = '';
					try {
						loginData = JSON.parse(localStorage.getItem('loginData'));
					}catch (err){
						// console.log(err)
					}
					if(!data.app_platform){
						data.app_platform = Constant.DEVICE;
					}
					if(loginData){
						if(!data.safeCode){
							data.safeCode = loginData.gtjSafeCode || '';
						}
						if(!data.safeTime){
							data.safeTime = loginData.safetime || '';
						}
						if(!data.mobile){
							data.mobile = loginData.member_phone || '';
						}
						if(!data.intl_tele_code){
							data.intl_tele_code = loginData.intl_tele_code || '';
						}
					}

					break;
				case 'success':
					var successfn = options[Key];
					break;
				case 'error':
				case 'fail':
					var errorfn = options[Key];
					break;
			}
		}

		axios({
			url : url,
			method : method,
			data : Qs.stringify(data),
		}).then((res) => {
			if(that.isString(res)){
				try {
					var oData = JSON.parse(res);
				}
				catch(e) {
					oData = res;
				}
			}else{
				oData = res;
			}
			that.isFunction(successfn) && successfn(oData);
		}).catch((res) =>{
			that.isFunction(errorfn) && errorfn(res);
		});
	},
	isString:function (obj) {
		return Object.prototype.toString.call(obj) === "[object String]";
	},
	isFunction:function (obj) {
		return Object.prototype.toString.call(obj) === "[object Function]";
	},
	JSONP: function (options) {
		var url = '';
		var params = '';
		var callBack = '';
		for(let Key in options){
			switch (Key){
				case 'url':
					url = options[Key];
					break;
				case 'data':
					var arr = [];
					for(var dataKey in options[Key]){
						arr.push(dataKey + '=' + options[Key][dataKey])
					}
					params = arr.join('&');
					break;
				case 'callback':
					callBack = '&callback=' + options[Key];
					break;
				case 'complate':
					var callBackFn = options["callback"];

					break;
			}
		}
		var script = document.createElement('script');
		    script.setAttribute("type","text/javascript");
		    if(/\?/.test(url)){
			    script.src = url + params + callBack;
		    }else{
			    script.src = url + '?' + params + callBack;
		    }
			document.body.appendChild(script);
		    function callBackFn(res) {
			    this.isFunction(options["complate"]) && callBackFn(res);
		    }
	}
}



// WEBPACK FOOTER //
// ./src/components/js/common.js